import React from 'react';
import { LockIcon, ZapIcon, ShieldCheckIcon, CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { ProductStack } from './ProductStack';
import { CHECKOUT_URL, PRODUCT_MOCKUP, PRODUCT_MOCKUP_ALT } from '../data/product';
const included = ['6 volumes: Day-One Ready to Season Ready', '136 ready-to-run Session Cards', 'The Four-Block Session, Level Ladder & Rotation Grid', '5 instant-use bonuses, incl. the Skill-Fault Fixer', 'Beginner, intermediate & rec on the same court', 'Lifetime access to your files'];
export function Pricing() {
  return <section id="pricing" aria-labelledby="pricing-heading" className="w-full bg-ice text-ink" data-id="element-168" data-mp="25sr1prez7vz4">
      <div className="max-w-2xl mx-auto px-5 py-16 sm:py-20" data-id="element-169" data-mp="20tej5iv51b2c">
        <div className="text-center" data-id="element-170" data-mp="20v7omuu0lp8r">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-gold-deep" data-id="element-171" data-mp="3h6v5tqfa30hw">
            Complete package
          </p>
          <h2 id="pricing-heading" className="mt-3 font-display font-bold uppercase text-ink text-3xl sm:text-5xl" data-id="element-172" data-mp="3c7i98dyluf24">
            A full year of lessons, clinics and drills, already planned
          </h2>
        </div>

        <div className="mt-8 overflow-hidden rounded-3xl border border-navy-line bg-navy-card shadow-card" data-id="element-173" data-mp="9si7tvwt2d03">
          <div className="bg-gold px-5 py-5 text-center" data-id="element-174" data-mp="erv5zct4n6hz">
            <h3 className="font-display text-xl uppercase tracking-wide text-gold-ink sm:text-2xl" data-id="element-175" data-mp="ep8z7fe28v0t">
              Court Ready — Complete Package
            </h3>
            <p className="mt-1 text-[13px] font-bold uppercase tracking-widest text-gold-ink/75" data-id="element-176" data-mp="3i93lvr4anwa2">
              6 Volumes + 5 Bonuses
            </p>
          </div>

          <div className="p-5 sm:p-7" data-id="element-177" data-mp="3rxlgtrpw795s">
            {PRODUCT_MOCKUP ? <img src={PRODUCT_MOCKUP} alt={PRODUCT_MOCKUP_ALT} width={2048} height={1360} loading="lazy" className="w-full rounded-2xl object-cover" data-id="element-178" data-mp="3rzy9ozx6v3xm" /> : <div className="overflow-hidden rounded-2xl bg-navy-deep px-3 py-4 sm:px-6 sm:py-6" data-id="element-179" data-mp="2rfa6hrr40jhg">
                <ProductStack className="mx-auto w-full max-w-[460px]" data-id="element-180" data-mp="2mh8koz2au62a" />
              </div>}

            <ul className="mt-6 grid gap-2.5 sm:grid-cols-2" data-id="element-181" data-mp="315weazsl45pl">
              {included.map(item => <li key={item} className="flex items-start gap-2 text-sm" data-id="element-182" data-mp="2w9o666ct1crx">
                  <span className="mt-0.5 flex h-[18px] w-[18px] flex-none items-center justify-center rounded-full bg-gold/20" data-id="element-183" data-mp="28is8wtpkxpda">
                    <CheckIcon className="h-3 w-3 text-gold-deep" aria-hidden="true" data-id="element-184" data-mp="23l0cbmdzpf2r" />
                  </span>
                  {item}
                </li>)}
            </ul>

            <div className="mt-7 border-t border-ice-dark pt-6 text-center" data-id="element-185" data-mp="2dfsez4mfis4e">
              <p className="text-[13px] text-ink-soft" data-id="element-186" data-mp="3tu0q831r1f0q">
                Total value <span className="text-ink-muted line-through" data-id="element-187" data-mp="3ows63wx1j0wu">$97 USD</span>
              </p>
              <div className="mt-1 flex items-start justify-center gap-1" data-id="element-188" data-mp="9uec5uymrka">
                <span className="mt-2.5 font-display text-3xl" data-id="element-189" data-mp="cq8dj3osw3g">$</span>
                <span className="font-display text-[56px] leading-[0.9] sm:text-7xl" data-id="element-190" data-mp="5arukcwetbj5">27</span>
                <span className="mt-3 text-[13px] font-bold text-ink-muted" data-id="element-191" data-mp="3ngo24meaxqvw">USD</span>
              </div>

              <div className="mt-3 flex flex-wrap justify-center gap-2" data-id="element-192" data-mp="3rgyjswbgi5ql">
                <span className="rounded border border-gold bg-gold px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest text-gold-ink" data-id="element-193" data-mp="j1wp50kx7dmm">
                  Save $70
                </span>
                <span className="rounded border border-ice-dark px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest text-ink-soft" data-id="element-194" data-mp="a7ia8z4ay541">
                  One-time payment
                </span>
                <span className="rounded border border-ice-dark px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest text-ink-soft" data-id="element-195" data-mp="11yod3nbeqgx0">
                  No subscription
                </span>
              </div>

              <CtaButton href={CHECKOUT_URL} className="mt-5" data-id="element-196" data-mp="3f93fhyjn7hmf">
                Get Court Ready — only $27
              </CtaButton>

              <p className="mt-3 text-xs text-ink-muted" data-id="element-197" data-mp="3aas43jdp8z23">
                Backed by the 7-day money-back guarantee
              </p>

              <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-medium text-ink-soft" data-id="element-198" data-mp="31897vi4f5kot">
                <li className="flex items-center gap-1.5" data-id="element-199" data-mp="1rkllxem9ge4">
                  <LockIcon className="h-4 w-4 text-gold-deep" aria-hidden="true" data-id="element-200" data-mp="3syx72omj8fzu" />
                  Secure checkout
                </li>
                <li className="flex items-center gap-1.5" data-id="element-201" data-mp="3o75d04463s4y">
                  <ZapIcon className="h-4 w-4 text-gold-deep" aria-hidden="true" data-id="element-202" data-mp="3k6lht635mylg" />
                  Access in 5 minutes
                </li>
                <li className="flex items-center gap-1.5" data-id="element-203" data-mp="kjwxpbv2nw1g">
                  <ShieldCheckIcon className="h-4 w-4 text-gold-deep" aria-hidden="true" data-id="element-204" data-mp="fsn9mfp690ro" />
                  7-day guarantee
                </li>
              </ul>
            </div>
          </div>
        </div>

        <p className="mt-4 text-center text-xs text-ink-muted" data-id="element-205" data-mp="23dpzy8n0yxme">
          Price in USD. You&apos;ll be charged the equivalent in your local currency.
        </p>
      </div>
    </section>;
}